import { object, string } from 'yup';

export default object().shape({
    username:
        string()
            .required('REQUIRED'),
    password:
        string()
            .required('REQUIRED')
});
